module.exports = "/InteressantActive@2x-df87550cf0157a7731cfdb8ba9199e95.png";